import type { ReactNode, MouseEvent } from 'react';

import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import { Modal } from '#/modals/Modal';

import {
  FilterDialogBody,
  FilterDialogFooter,
  FilterDialogHeader,
  FilterDialogOverlay,
  FilterDialogPanel,
  FilterDialogTitle,
} from './MobileSearchFilterDialog.styled';

type Props = {
  onClose: () => void;
  onClearFilters: () => void;
  children: ReactNode;
};

export function MobileSearchFilterDialog({
  onClose,
  onClearFilters,
  children,
}: Props) {
  const { i18n } = useI18n();

  const handleOverlayClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal
      onClose={onClose}
      // oxlint-disable-next-line jsx-no-useless-fragment
      customOverlay={<></>}
      render={() => (
        <FilterDialogOverlay
          onClick={handleOverlayClick}
          data-qa-id="filter-dialog-overlay"
        >
          <FilterDialogPanel>
            <FilterDialogHeader>
              <FilterDialogTitle>{i18n('Filters')}</FilterDialogTitle>
              <Button
                type="button"
                variant="tertiary"
                noPadding
                icon={{ name: 'close' }}
                aria-label={i18n('Close filters')}
                qaId="close-filter-dialog"
                onClick={onClose}
              />
            </FilterDialogHeader>

            <FilterDialogBody>{children}</FilterDialogBody>

            <FilterDialogFooter>
              <Button
                type="button"
                variant="secondary"
                onClick={onClearFilters}
                qaId="clear-filters"
              >
                {i18n('Clear Filters')}
              </Button>
              <Button
                type="button"
                variant="primary"
                onClick={onClose}
                qaId="apply-filters"
              >
                {i18n('Apply Filters')}
              </Button>
            </FilterDialogFooter>
          </FilterDialogPanel>
        </FilterDialogOverlay>
      )}
    />
  );
}
